// App.js
import React from 'react';
import './App.css';
import LandingPage from "./components/Home";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
    return (
        <div className="App">
            <LandingPage/>
        </div>
    );
}

export default App;